/*
// jei reikia, galime perrasyti core komponentus, pvz.
init_tooltips = function(context) {
	$('[data-toggle="tooltip"]', context).tooltip({placement:'bottom'});
}
*/

(function( $ ) {
    $.fn.qtySelect = function() {

        return this.each(function() {
            var parent = $(this);
            var input = $('input', parent);
            var value = $('.value', parent);

            $('.plus', parent).off('click');
            $('.plus', parent).on('click', function(e){
                e.preventDefault();
                var qty = parseInt(input.val()) + 1;
                if (qty >= input.attr('max')) {
                    qty = input.attr('max');
                }
                input.val(qty);
                input.change();
                if(!parent.hasClass('with-input')) {
                    value.html(qty);
                }
                if (qty > 0) $('.minus', parent).removeClass('disabled');
                if (qty >= input.attr('max')) $('.plus', parent).addClass('disabled');
                if ($(this).hasClass('submit')) {
                    parent.closest('form').submit();
                }
            });

            $('.minus', parent).off('click');
            $('.minus', parent).on('click', function(e){
                e.preventDefault();
                var qty = parseInt(input.val()) - 1;
                if (qty < 0) qty = 0;
                input.val(qty);
                input.change();
                if(!parent.hasClass('with-input')) {
                    value.html(qty);
                }
                if (qty == 0) $('.minus', parent).addClass('disabled');
                if (qty < input.attr('max')) $('.plus', parent).removeClass('disabled');
                if ($(this).hasClass('submit')) {
                    parent.closest('form').submit();
                }
            });

        });
    };

}( jQuery ));

$(function () {
    update_breadcrumb();
    update_product_list_select();

    $(window).resize(function() {
        update_breadcrumb();
    });
    $('.qty-select').qtySelect();

});